{
  "group": "layer",
  "format": "wkt",
  "dbs": "NEON",
  "table": "test.scratch",
  "srid": "3857",
  "geom": "geom_3857",
  "qID": "id"
}
